import { IOrderStatus } from '../types/newbuilding/flatViewOrder';
import { IUserBookingStatus } from '../repositories/newbuilding-flat-tour-booking/entities/Models/UserBookingStatus';

export const transformUserBookingStatus = (data: IUserBookingStatus): IOrderStatus => {
  return {
    type: data.type === 'signedUp' ? 'signedUp' : 'noActive',
    description: data.description,
  };
};
